import { countryIsoCodeToName } from "../../formatters";

const Name = ({ fallback = "", children }) => {
    if (!children) {
        return null;
    }

    return countryIsoCodeToName(children) || fallback;
};

export default Name;
